export enum AdminRecruiterSections {
  Recruiters = 'members',
}
